import { GlobalNotification, Icons, Link } from '@lacedltd/laced-components'
import * as React from 'react'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { useLocale, useTranslation } from 'hooks'
import { withGrowthbook, withTranslations } from 'helpers'
import * as S from './HolidaySeasonDeliveryGuaranteeBanner.styles'

const onValidPage = (path: string) => {
  return !(path.includes('admin') || path.includes('checkout'))
}

const HolidaySeasonDeliveryGuaranteeBanner = () => {
  const { localiseUrl, location } = useLocale()
  const { t } = useTranslation()
  const pdArrivesBeforeChristmas = useFeatureIsOn('pd_arrives_before_christmas')
  const pdArrivesBeforeNewYear = useFeatureIsOn('pd_arrives_before_new_year')

  if (!onValidPage(window.location.pathname)) return null
  if (location.code !== 'GB') return null

  let message = ''

  if (pdArrivesBeforeChristmas) {
    message = t('react_components.seasonal.banner.guaranteed_before_christmas')
  }

  if (pdArrivesBeforeNewYear) {
    message = t('react_components.seasonal.banner.guaranteed_before_nye')
  }

  if (!message) return null

  return (
    <Link
      href={'https://help.laced.com/hc/en-gb/articles/6335480955292'}
      size="m"
      darkMode
    >
      <GlobalNotification>
        <S.CentredRow>
          {message} <Icons.Right size="s" />
        </S.CentredRow>
      </GlobalNotification>
    </Link>
  )
}

export default withGrowthbook(
  withTranslations(HolidaySeasonDeliveryGuaranteeBanner)
)
